import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 960px) {
    .description {
      max-width: 320px !important;
    }
    .details {
      max-width: 360px !important;
      padding: 0 4px;
    }
  }

  .checkcircle {
    width: 54.55px;
    height: 54.55px;
  }

  .title {
    font-size: 24px;
    font-weight: 700;
    padding: 18.7px 0 12px 0;
    color: #070c2f;
  }

  .description {
    max-width: 400px;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: ${(props) => props.theme.colors.black};
    line-height: 20px;
  }

  .details {
    max-width: 400px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    line-height: 20px;

    p {
      font-size: 16px;
      font-weight: 700;
      color: ${(props) => props.theme.colors.gray};
    }

    span {
      font-size: 16px;
      font-weight: 400;
      color: ${(props) => props.theme.colors.gray};
      margin-left: 3px;
    }
  }

  .btn_finish {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;

    button {
      width: 132px;
    }

    p {
      font-size: 16px;
      color: ${(props) => props.theme.colors.white};
    }
  }
`;
